import { PageHeading } from "../../../components/common/pageHeading/PageHeading";
import bg from "../../../assests/images/inventory_bg.avif";
import { OrderData } from "../../../components/orderData/OrderData";
import { useIsSalesExecutive } from "../../../customHooks/roleChecker/useIsSalesExecutive";
import { NavLink } from "react-router-dom";
import { useIsSeniorSalesExecutive } from "../../../customHooks/roleChecker/useIsSeniorSalesExecutive";
export const Orders = () => {
  const isSalesExecutive = useIsSalesExecutive();
  const isSeniorSalesExecutive = useIsSeniorSalesExecutive();
  return (
    <div className="mb-5">
      <PageHeading title={"Order"} />
      <section className="container py-2">
        <div className="row align-items-center">
          <div className="col-12 col-md-6 text-center">
            <h1 className="display-4">Supply Corner</h1>
            <p className="lead">Order information</p>
            {isSalesExecutive || isSeniorSalesExecutive ? (
              <NavLink
                to="/reporting"
                className="btn btn-outline-warning btn-lg"
              >
                Reporting
              </NavLink>
            ) : (
              <NavLink
                to="/dashboard"
                className="btn btn-outline-warning btn-lg"
              >
                Dashboard
              </NavLink>
            )}
          </div>
          <div className="col-md-6">
            <img
              src={bg}
              className="img-fluid rounded"
              alt="Order management"
            />
          </div>
        </div>
      </section>
      <OrderData />
    </div>
  );
};
